<script setup lang="ts">
import UserAvatar from "@/components/ui/UserAvatar/UserAvatar.vue";
import type { AuthUser } from "@/model/user";

defineProps<{ reporters: AuthUser[] }>();
</script>

<template>
  <div>{{ $t("general.reporters") }}</div>
  <div v-for="reporter in reporters" :key="reporter.id" class="shortcut">
    <UserAvatar :user="reporter" size="small" />
    {{ reporter.name }}
  </div>
</template>

<style lang="scss" scoped>
.shortcut {
  margin-top: 0.2em;
  display: flex;
  gap: 0.5em;
}
</style>
